import React from "react";
import { addIndex, applySpec, map, partial } from "ramda";
import { connect } from "react-redux";
import {
  showAddContributorDialog,
  showEditContributorDialog,
  showRemoveContributorDialog,
} from "edit-media/redux/editMediaActions";
import {
  getEditMediaItemContributors,
  getEditMediaErrors,
} from "common/selectors";
import { Button, IconButton } from "react-toolbox/lib/button";
import { formatContributorName } from "util/stringFormat";
import { firstError } from "util/validation";
import styles from "edit-media/components/EditMediaContributorsTab.css";

const createContributorRow = (onEditContributor, onRemoveContributor) => (
  contributor,
  index,
) => (
  <div key={`details-contributor-${index}`} className={styles.contributorRow}>
    <span className={styles.contributorName}>
      {formatContributorName(contributor)}
    </span>
    <IconButton
      className={styles.editButton}
      theme={{ width: "10px" }}
      icon="edit"
      onClick={partial(onEditContributor, [index])}
    />
    <IconButton
      className={styles.removeButton}
      icon="delete"
      onClick={partial(onRemoveContributor, [index])}
    />
  </div>
);

const EditMediaContributorsTab = ({
  contributors,
  errors,
  onAddContributor,
  onEditContributor,
  onRemoveContributor,
}) => (
  <div>
    <div className={styles.contributorsContainer}>
      {addIndex(map)(
        createContributorRow(onEditContributor, onRemoveContributor),
        contributors,
      )}
    </div>
    <div className={styles.row}>
      <Button raised onClick={onAddContributor}>
        Add a contributor
      </Button>
      <div className={styles.errorRow}>
        <p>{firstError(errors, "contributors")}</p>
      </div>
    </div>
  </div>
);

const mapStateToProps = applySpec({
  contributors: getEditMediaItemContributors,
  errors: getEditMediaErrors,
});

const mapDispatchToProps = dispatch => ({
  onAddContributor: () => dispatch(showAddContributorDialog()),
  onEditContributor: index => dispatch(showEditContributorDialog(index)),
  onRemoveContributor: index => dispatch(showRemoveContributorDialog(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  EditMediaContributorsTab,
);
